/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: Paytable.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */ 
namespace Paytable {
    /**
     * Constants to describe the position of the single items in the Paytable etc.
     * The example structure given here is recommended but you can also use your own style
     * or none at all and make a really ugly non maintanable PaytableClass
     */
    export class PaytableStyle {
        public static readonly PAYTABLE_SD = {
            payItemTextformat: {font: "Impact", fontSize: 22, fill: 0xEEEE00, align: "right", fontStyle: 'normal', stroke: "#000", strokeThickness: 1},
            payItemWidth: 85,
            payItemHeight: 30,
            scatterCapital: {
                x: 290,
                y: 285,
                width: 340,
                height: 49
            },
            scatterLine1: {
                x: 290,
                y: 327,
                width: 340,
                height: 36
            },
            scatterLine2: {
                x: 290,
                y: 355,
                width: 340,
                height: 36
            },
             payGroups: [
                {
                    x: 770,
                    y: 364,
                    symbols: [0],
                    positions: [
                        {x: 0, y: 75},
                        {x: 0, y: 50},
                        {x: 0, y: 25},
                        {x: 0, y: 0}
                    ],
                },//Cherry
                {
                    x: 333,
                    y: 438,
                    symbols: [1],
                    positions: [
                        {x: 0, y: 50},
                        {x: 0, y: 25},
                        {x: 0, y: 0}
                    ],
                },//Orange
                {
                    x: 552,
                    y: 440,
                    symbols: [2],
                    positions: [
                        {x: 0, y: 50},
                        {x: 0, y: 25},
                        {x: 0, y: 0}
                    ],
                },//Lemon
                {
                    x: 115,
                    y: 365,
                    symbols: [3],
                    positions: [
                        {x: 0, y: 50},
                        {x: 0, y: 25},
                        {x: 0, y: 0}
                    ],
                },//Plum
                {
                    x: 710,
                    y: 154,
                    symbols: [4],
                    positions: [
                        {x: 0, y: 50},
                        {x: 0, y: 25},
                        {x: 0, y: 0}
                    ],
                },//Grapes
                {
                    x: 174,
                    y: 154,
                    symbols: [5],
                    positions: [
                        {x: 0, y: 50},
                        {x: 0, y: 25},
                        {x: 0, y: 0}
                    ],
                },//Melon
                {
                    x: 450,
                    y: 243,
                    symbols: [6],
                    positions: [
                        {x: 0, y: 50},
                        {x: 0, y: 25},
                        {x: 0, y: 0}
                    ],
                }//Sun
            ]
        };
        public static readonly PAYTABLE_HD = {
            payItemTextformat: {font: "Impact", fontSize: 45, fill: 0xEEEE00, align: "right", fontStyle: 'normal', stroke: "#000", strokeThickness: 1},
            payItemWidth: 200,
            payItemHeight: 70,
            scatterCapital: {
                x: 290,
                y: 285,
                width: 340,
                height: 49
            },
            scatterLine1: {
                x: 290,
                y: 327,
                width: 340,
                height: 36
            },
            scatterLine2: {
                x: 290,
                y: 355,
                width: 340,
                height: 36
            },
            payGroups: [
                {
                    x: 1550,
                    y: 737,
                    symbols: [0],
                    positions: [
                        {x: 0, y: 150},
                        {x: 0, y: 100},
                        {x: 0, y: 50},
                        {x: 0, y: 0}
                    ],
                },//Cherry
                {
                    x: 1115,
                    y: 885,
                    symbols: [1],
                    positions: [
                        {x: 0, y: 100},
                        {x: 0, y: 50},
                        {x: 0, y: 0}
                    ],
                },//Orange
                {
                    x: 680,
                    y: 885,
                    symbols: [2],
                    positions: [
                        {x: 0, y: 100},
                        {x: 0, y: 50},
                        {x: 0, y: 0}
                    ],
                },//Lemon
                {
                    x: 240,
                    y: 740,
                    symbols: [3],
                    positions: [
                        {x: 0, y: 100},
                        {x: 0, y: 50},
                        {x: 0, y: 0}
                    ],
                },//Plum
                {
                    x: 360,
                    y: 319,
                    symbols: [4],
                    positions: [
                        {x: 0, y: 100},
                        {x: 0, y: 50},
                        {x: 0, y: 0}
                    ],
                },//Grapes
                {
                    x: 1435,
                    y: 319,
                    symbols: [5],
                    positions: [
                        {x: 0, y: 100},
                        {x: 0, y: 50},
                        {x: 0, y: 0}
                    ],
                },//Melon
                {
                    x: 915,
                    y: 494,
                    symbols: [6],
                    positions: [
                        {x: 0, y: 100},
                        {x: 0, y: 50},
                        {x: 0, y: 0}
                    ],
                }//Sun 
            ]
        };
    }
}